/**
 * Web Pages constants
 * @author Akash Salvi <akash.salvi@helpshift.com>
 * @created May 22, 2025
 * @module constants/pages
 */

export const PREFERRED_LANG_LS_KEY = "loginPrefLang";
